// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + "03a05a4f3d7a9a60308b" + ".chunk.js";
};